// extracted by mini-css-extract-plugin
module.exports = {"sider":"CollapsibleSider_sider__SdrfP","siderContent":"CollapsibleSider_siderContent__KAmAa","collapsed":"CollapsibleSider_collapsed__6r7eJ"};